export const PERMISSION_STATE = {
	DENIED: 'denied',
	GRANTED: 'granted',
	PROMPT: 'prompt'
} as const;
export type TPermissionState = typeof PERMISSION_STATE[keyof typeof PERMISSION_STATE];
